import { OperatorsEnum } from '../../utils/enum/OperatorsType';
import {
    DateRangeScopeProps,
    ScopeProps,
} from '../Dashboard/dashboardInterfaces';
import { QUESTION_TYPE } from '../Modals/DashboardModal/constants';

export interface ColorHotAlertInterface {
    color: string
    fontColor: string
}

export interface StatusHotAlertsInterface {
    id?: number
    label: string,
    color: ColorHotAlertInterface
}

export interface VariablesHotAlertsInterface {
    id: string
    label: string
    value?: string
}

export interface HotAlertsInterface {
    id: number,
    satisfaction: boolean,
    status: StatusHotAlertsInterface
    answerVerbatim: string
    lastname: string
    firstname: string
    answerDate: Date
    variables: VariablesHotAlertsInterface[]
}

export interface ColumnsInterface {
    id: string,
    label: string
}
export interface HotAlertColumnInterface{
    id: number
    code: number
    name: string
    label: string
    shortlabel: string
    type: QUESTION_TYPE
    isopen: boolean
    issatisfaction: boolean
    modalities?: string[]
}
export enum KPI_TYPE {
    SATISFACTION = 'SATISFACTION'
}

export enum SATISFACTION_LEVEL {
    SATISFY = 'SATISFY',
    UNSATISFY = 'UNSATISFY',
    NEUTRAL = 'NEUTRAL'
}

export interface HotAlertSatisfactionInterface{
    questionId: number
    type: KPI_TYPE
    positiveModalityIds: number[]
    negativeModalityIds: number[]
}

export interface HotAlertStatusInterface{
    id: number
    label: string
    color: {
        color: string
        fontColor: string
    }
    isDefault: boolean
    isFinal: boolean
}

export interface HotAlertAnswersInterface{
    questionid: number
    modality_code: number[]
    label: string
    answer_id: number
    answer: string[]
    rank: number
}
export interface GetHotAlertDataInterface{
    hotAlertId: number
    interviewid: number
    interviewDate: Date
    status: string
    answers: HotAlertAnswersInterface[]
}
export interface GetHotAlertsInterface {
    total: number
    columns: HotAlertColumnInterface[]
    satisfactionConfiguration?: HotAlertSatisfactionInterface
    status: HotAlertStatusInterface[]
    datas: GetHotAlertDataInterface[]
}

export interface HotAlertsCountInterface {
    numberToTreat: number
    numberOfClosed: number
}

export interface HeaderHotAlertsSummaryProps {
    name: string
    question: {
        questionLabel: string
        questionId: number
        questionType: string
    }
}

export interface OperatorInterface {
    id: OperatorsEnum,
    label: string,
    code: string
}

export const Operators: OperatorInterface[] = [
    { id: OperatorsEnum.SUPERIOR_EQUAL, label: '>=', code: '&gt;=' },
    { id: OperatorsEnum.INFERIOR_EQUAL, label: '<=', code: '&lt;=' },
    { id: OperatorsEnum.EQUAL, label: '=', code: '=' },
];
export interface FilterDateInterface {
    date: Date | null
    operator: OperatorsEnum | null
}

export interface GetHistoricalProps {
    questionLabel: string
    modalities: string[]
    hotAlertCounts: number[]
    toTreatHotAlertCounts: number[]
}

export interface HistoricalTemporalityOption {
    value: string
    label: string
}

export interface SummaryBoxProps {
    displayExport: boolean
    hasStatus: boolean
    numberOfhotAlerts: number
    hotAlertCounts: HotAlertsCountInterface
    surveyId: string
    historical: GetHistoricalProps
    selectedScope: Array<ScopeProps>
    selectedDateRange: DateRangeScopeProps | null
    historicalTemporalityOptions: HistoricalTemporalityOption[]
    selectedHistoricalTemporality: string
    handleChangeHistoricalTemporality: (temporality: string) => void
}
